import TaxesModalContentContainer from './TaxesModalContentContainer';

export default TaxesModalContentContainer;
